import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import * as jwt_decode from 'jwt-decode';
import * as moment from 'moment';
import 'rxjs/add/operator/delay';

import { environment } from '../../../environments/environment';
import { of, EMPTY } from 'rxjs';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + btoa('OAuth2WebUser:secret')
    })
};

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {
    private apiServerUrl = environment.apiServer;
    private loginUrl = environment.apiServer + '/oauth/token';
    private resetUrl = environment.apiServer + '/users/forgotPaswword';
    public defaultImg = "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";
    public alreadyLoggedOut = false;
    constructor(private http: HttpClient,
        @Inject('LOCALSTORAGE') private localStorage: Storage) {
    }

    login(email: string, password: string) {
        return this.http.post(this.loginUrl, { login: email, password: password }, httpOptions)
            .pipe(map((response) => {
                // set token property
                const decodedToken = jwt_decode(response['access_token']);
                console.log(decodedToken);
                // store email and jwt token in local storage to keep user logged in between page refreshes
                this.localStorage.setItem('currentUser', JSON.stringify({
                    token: response['access_token'],
                    isAdmin: decodedToken.user.role && decodedToken.user.role == "ADMIN",
                    email: decodedToken.user_name,
                    role: decodedToken.user.role,
                    expiration: moment().add(decodedToken.exp, 'ms').toDate(),
                    firstName: decodedToken.user.firstName,
                    lastName: decodedToken.user.lastName,
                    img: decodedToken.user.photoProfil,
                    centers:decodedToken.user.centresId,
                    civility: decodedToken.user.civilite,
                    id: decodedToken.user.id,
                    idRegion: decodedToken.user.idRegion,
                    libRegion: decodedToken.user.libRegion,
                    userKey: decodedToken.user.userKey,
                    centresId: decodedToken.user.centresId ? decodedToken.user.centresId : [],
                    hasCentre : decodedToken.user.hasCentre
                }));
                this.alreadyLoggedOut = false;
                return true;
            }));
    }

    logout(expiredSession): void {
        // clear token remove user from local storage to log user out
        //    this.localStorage.removeItem('currentUser');
        this.localStorage.clear();
        this.alreadyLoggedOut = expiredSession;
    }

    getCurrentUser(): any {
        return JSON.parse(this.localStorage.getItem('currentUser'));
    }

    passwordResetRequest(email: string) {
        return this.http.post(this.resetUrl + "?email=" + email, null);
    }

    changePassword(email: string, currentPwd: string, newPwd: string) {
        return of(true).delay(1000);
    }

    passwordReset(email: string, token: string, password: string, confirmPassword: string): any {
        return of(true).delay(1000);
    }

    hasAnyRole(roles: string[]) {
        const user = this.getCurrentUser();
        if (user && roles.includes(user.role)) {
            return true;
        }
        return false;
    }

    getUserCenters(){
        return this.getCurrentUser().centers;
    }

    checkKeyValidity(key) {
        return this.http.get(this.apiServerUrl + "/activationLinks/checkValidity?activationLinkKey=" + key);
    }
}
